import type { ReactNode } from "react";

import { Button } from "../../shared/ui/button";
import { Spinner } from "../../shared/ui/spinner";
import {
  OnboardingContent,
  OnboardingFrame,
  OnboardingHeading,
} from "./OnboardingFrame";

export function Status({ children }: { children: ReactNode }) {
  return (
    <OnboardingFrame>
      <OnboardingContent>
        <div className="flex items-center justify-center gap-2 py-2 text-sm text-foreground-muted">
          <Spinner />
          <span>{children}</span>
        </div>
      </OnboardingContent>
    </OnboardingFrame>
  );
}

interface JoinErrorProps {
  message?: ReactNode;
  onReset?: () => void;
  heading?: string;
  actionLabel?: string;
}

export function JoinError({
  message,
  onReset,
  heading = "CAN'T JOIN TEAM",
  actionLabel = "START OVER",
}: JoinErrorProps) {
  return (
    <OnboardingFrame>
      <OnboardingHeading title={heading} description={message} />
      {onReset ? (
        <OnboardingContent>
          <Button
            type="button"
            onClick={onReset}
            variant="outline"
            className="w-full"
          >
            {actionLabel}
          </Button>
        </OnboardingContent>
      ) : null}
    </OnboardingFrame>
  );
}
